export default __webpack_public_path__ + "static/media/egg-step1-video.9fca3f41.mp4";